module.exports = __webpack_public_path__ + "img/GR089.fe0581ef.png";